import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';
import { useAuthContext } from '../context';

/** Posts the raw signed `initData`; the API verifies the signature. useProfile loads the rest. */
export const useTelegramMiniAppLogin = () => {
  const queryClient = useQueryClient();
  const {
    methods: { setTokens },
  } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.TelegramMiniAppSignIn.Request) => {
      const { data } = await Api.TelegramMiniAppSignIn(values);
      return data;
    },
    onSuccess: (data) => {
      queryClient.removeQueries({ queryKey: ['auth', 'profile'] });
      setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken });
    },
  });
};
